import React, { Fragment } from "react";
import { CategoryTag, Favourite, Locale } from "../../core/api/model";
import { useIntl } from "react-intl";
import { DashboardFavouritesCorporationsList, DashboardFavouritesParticipantsList, DashboardFavouritesEventsList } from "../DashboardFavouritesList";
import { DashboardPanel, DashboardPanelItem } from "../DashboardPanel";

export interface DashboardFavouritesPanelProps {
  locale: Locale;
  favourites: Favourite;
  deleteFavourite: (elementId: number, categoryTag: CategoryTag) => void;
}

export const DashboardFavouritesPanel = (props: DashboardFavouritesPanelProps) => {
  const intl = useIntl();

  return (
    <Fragment>
      <DashboardPanel
        title={intl.formatMessage({id: 'DashboardFavouritesTitle'})}
      >
        <DashboardPanelItem tabtitle={intl.formatMessage({id: 'DashboardFavouritesCooperations'})}>
          <DashboardFavouritesCorporationsList
            locale={props.locale}
            corporations={props.favourites.corporation
              .slice()
              .sort((a, b) => {
                switch(props.locale) {
                  case Locale.DE: {
                    return a.corpName.de_DE < b.corpName.de_DE ? -1 : 1
                  }
                  case Locale.EN: {
                    return a.corpName.en_GB < b.corpName.en_GB ? -1 : 1
                  }
                  default: {
                    return 0
                  }
                }
              })
            }
            deleteFavourite={props.deleteFavourite}
          />
        </DashboardPanelItem>

        <DashboardPanelItem
          tabtitle={intl.formatMessage({id: 'DashboardFavouritesParticipants'})}
        >
          <DashboardFavouritesParticipantsList
            locale={props.locale}
            participants={props.favourites.participant
              .slice()
              .sort((a, b) => ( `${a.partName} ${a.partSurname}` < `${b.partName} ${b.partSurname}` ? -1 : 1 ))
            }
            deleteFavourite={props.deleteFavourite}
          />
        </DashboardPanelItem>

        <DashboardPanelItem
          tabtitle={intl.formatMessage({id: 'DashboardFavouritesEvents'})}
        >
          <DashboardFavouritesEventsList
            locale={props.locale}
            events={props.favourites.event
              .slice()
              .sort((a, b) => ( a.eventBegin < b.eventBegin ? -1 : 1 ))
            }
            deleteFavourite={props.deleteFavourite}
          />
        </DashboardPanelItem>
      </DashboardPanel>
    </Fragment>
  );
};
